import React from "react";
import * as S from "./Breadcrumb.styles";
import { BreadcrumbLinkProps } from "./Link";
import { BreadCrumbLink } from "./Link.styles";
import { useMediaQuery } from "./useMediaQuery";

import { Tooltip } from "../Tooltip";

export type BreadcrumbItemProps = {
  label: string;
  isActive?: boolean;
  to: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  LinkComponent?: React.ComponentType<BreadcrumbLinkProps>;
};

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  label,
  isActive,
  to,
  onClick,
  LinkComponent = BreadCrumbLink
}) => {
  const lessThan1100 = useMediaQuery(`(max-width: 1100px)`);
  const lessThan950 = useMediaQuery(`(max-width: 950px)`);

  const charLength = lessThan950 ? 3 : lessThan1100 ? 9 : 12;
  const labelSlice = label.slice(0, charLength);

  const labelComponent =
    labelSlice.length === label.length ? (
      <>{label}</>
    ) : (
      <Tooltip tooltip={label}>{labelSlice}...</Tooltip>
    );

  return (
    <S.Wrapper>
      <LinkComponent to={to} $isActive={isActive} onClick={onClick}>
        {labelComponent}
      </LinkComponent>
      {!isActive && <S.Chevron color="var(--mode-overrides-header-vector)" />}
    </S.Wrapper>
  );
};
